import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Sentry 初始化:只在有 DSN 時才啟用(避免開發環境噴錯)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    // Release tracking:用 build time 作為版本號（可改成從 VITE_GIT_SHA 讀）
    release:
      import.meta.env.VITE_SENTRY_RELEASE ||
      `unified-commerce-hub@${new Date().toISOString()}`,
    // Performance:採樣 10% 交易；可用 tracesSampler 動態調整
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,
    ),
    // Replay:只在錯誤時錄(保護使用者隱私)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // GDPR:不送預設 PII
    sendDefaultPii: false,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
